import { FC } from 'react'

import styled from 'styled-components'

import Trash from 'src/Assets/trash.svg?react'
import { colors, device } from 'src/Helpers/constants.ts'
import { IconButton } from 'src/Components/Button/IconButton.tsx'
import { ModelType } from 'src/Redux/api/modelTypesApi.ts'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 5px;
  gap: 10px;
  background-color: ${colors.mainGray};
  padding: 10px;
`

const ParametersContainer = styled.div`
  position: relative;
  display: grid;
  grid-column-gap: 16px;
  grid-template-columns: 0.6fr 0.5fr;

  @media ${device.tabletMax} {
    grid-template-columns: 1fr;
    row-gap: 12px;
  }
`

const Name = styled.span`
  font-size: 14px;
  max-width: 200px;
  width: 100%;
  text-align: left;
  color: ${colors.thirdGray};
  font-weight: 600;
`

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  @media ${device.tabletMax} {
    position: absolute;
    top: 0;
    right: 0;
  }
`

const NameWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  width: 250px;

  @media ${device.tabletMax} {
    width: 100%;
    gap: 12px;
  }
`

const StyledButton = styled(IconButton)`
  background-color: ${colors.red};

  &:hover {
    background-color: ${colors.red};
  }
  margin-left: auto;
`

interface CatalogItemProps {
  onArchiveItem: (id: number) => void
  modelType: ModelType
}

export const ModelTypeItem: FC<CatalogItemProps> = ({
  onArchiveItem,
  modelType,
}) => {
  if (!modelType) {
    return null
  }

  const { label, id } = modelType

  const onArchiveItemClick = (): void => {
    onArchiveItem(id)
  }

  return (
    <Container>
      <ParametersContainer>
        <NameWrapper data-testid='transport-type-name'>
          <Name>{label}</Name>
        </NameWrapper>

        <ButtonContainer>
          <StyledButton
            onClick={onArchiveItemClick}
            tooltiptext={'Удалить тип техники'}
            data-testid='delete-transport-type-button'
          >
            <Trash />
          </StyledButton>
        </ButtonContainer>
      </ParametersContainer>
    </Container>
  )
}
